import React from "react";
import { Helmet } from "react-helmet";

export function SEO({ description, lang = "en", meta = [], title = null }) {
  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title ? `${title} - McLeod Software` : "McLeod Software"}
      meta={[
        {
          name: `description`,
          content: description
        },
        {
          name: "keywords",
          content: ""
        },
        {
          property: `og:title`,
          content: title
        },
        {
          property: `og:description`,
          content: description
        },
        {
          property: `og:type`,
          content: `website`
        },
        {
          name: `twitter:card`,
          content: `summary`
        },
        {
          name: `twitter:title`,
          content: title
        },
        {
          name: `twitter:description`,
          content: description
        }
      ].concat(meta)}
    />
  );
}
